import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="email-checker"
export default class extends Controller {
  static targets = [ "emailInput", "loginHelpText" ]
  static values = {
    loginPath: String,
    currentUrl: String
  }

  connect() {
    // No need to initialize any elements
  }

  async checkEmail(event) {
    const email = this.emailInputTarget.value;
    if (!this.isValidEmail(email)) {
      // Email is invalid, use gray color for the help text
      this.loginHelpTextTarget.classList.remove('text-red-500');
      this.loginHelpTextTarget.classList.add('text-gray-500');
      return;
    }

    try {
      const response = await fetch(`/users/check_email?email=${encodeURIComponent(email)}`, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      const result = await response.json();
      
      if (result.exists) {
        // Highlight the login help text in red when email exists
        this.loginHelpTextTarget.classList.remove('text-gray-500');
        this.loginHelpTextTarget.classList.add('text-red-500');
      } else {
        // Use gray color when email doesn't exist
        this.loginHelpTextTarget.classList.remove('text-red-500');
        this.loginHelpTextTarget.classList.add('text-gray-500');
      }
    } catch (error) {
      console.error("Error checking email:", error);
    }
  }
  
  isValidEmail(email) {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  }
}
